<template>
    <v-list-tile @click="">
        <v-list-tile-content>
            <template v-if="exceptionType === 'string'">
                <v-list-tile-title>{{exception}}</v-list-tile-title>
            </template>
            <template v-else-if="exceptionType === 'object'">
                <v-list-tile-title>{{exception.message}}</v-list-tile-title>
                <v-list-tile-sub-title>
                    <div v-for="(item, index) in exception.data" :key="index">
                        <span v-for="(value, key) in item" :key="key">
                            {{key}}: {{value}}
                        </span>
                    </div>
                </v-list-tile-sub-title>
            </template>
        </v-list-tile-content>
    </v-list-tile>
</template>

<script>
  export default {
    name: 'JobException',
    props: {
      exception: {
        required: true
      }
    },
    computed: {
      exceptionType () {
        return typeof this.exception
      }
    }
  }
</script>

<style scoped>

</style>